import React, { useState } from 'react';
import { useSubscription } from '../contexts/SubscriptionContext';
import { Icons } from './Icons';

// Firestore/Storage rules already reject all writes for both 'grace' and
// 'blocked' (see hasFullAccess() in firestore.rules) — this component is
// purely informational, so users understand why write actions fail instead
// of hitting a silent permission-denied error.
export default function AccessWall({ onUpgradeClick }) {
  const { accessState, subscription } = useSubscription();
  const [dismissedBlocked, setDismissedBlocked] = useState(false);

  if (accessState === 'grace') {
    const remaining = Math.max(0, 20 - (subscription.graceLoginsUsed || 0));
    return (
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 250,
        background: '#2C2418', color: '#F5EDE3',
        padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
        fontFamily: "'DM Sans', sans-serif", fontSize: 12.5,
        borderBottom: '1px solid rgba(196,151,90,0.3)',
        textAlign: 'center', flexWrap: 'wrap',
      }}>
        <span style={{ color: '#C4975A', display: 'flex', flexShrink: 0 }}><Icons.Lock size={15} /></span>
        <span>
          Your subscription has ended — you're in read-only mode ({remaining} of 20 logins remaining before full lockout).
          Download your data or resubscribe to keep editing.
        </span>
        <button
          onClick={onUpgradeClick}
          style={{
            flexShrink: 0, background: 'linear-gradient(135deg, #C4975A 0%, #A07840 100%)',
            border: 'none', borderRadius: 7, color: '#2C2418', fontSize: 12, fontWeight: 700,
            padding: '6px 12px', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
          }}
        >
          Resubscribe
        </button>
      </div>
    );
  }

  if (accessState === 'blocked') {
    if (dismissedBlocked) {
      return (
        <button
          onClick={() => setDismissedBlocked(false)}
          style={{
            position: 'fixed', bottom: 20, left: 20, zIndex: 250,
            background: '#C0392B', color: '#fff', border: 'none', borderRadius: 24,
            padding: '10px 16px', display: 'flex', alignItems: 'center', gap: 8,
            fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
            boxShadow: '0 4px 16px rgba(192,57,43,0.4)',
          }}
        >
          <Icons.Lock size={14} /> Account locked
        </button>
      );
    }

    return (
      <div style={{
        position: 'fixed', inset: 0, zIndex: 250,
        background: 'rgba(44,36,24,0.7)', backdropFilter: 'blur(3px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
      }}>
        <div style={{
          width: 440, maxWidth: '100%', background: '#FDFBF7', borderRadius: 20,
          boxShadow: '0 24px 64px rgba(0,0,0,0.3)', fontFamily: "'DM Sans', sans-serif",
          padding: '32px 28px', textAlign: 'center',
        }}>
          <div style={{
            width: 56, height: 56, borderRadius: '50%', margin: '0 auto 16px',
            background: 'rgba(192,57,43,0.12)', display: 'flex',
            alignItems: 'center', justifyContent: 'center', color: '#C0392B',
          }}>
            <Icons.Lock size={26} />
          </div>
          <h2 style={{ margin: '0 0 10px', fontSize: 20, fontFamily: "'Crimson Pro', Georgia, serif", fontWeight: 700, color: '#2C2418' }}>
            Your account is locked
          </h2>
          <p style={{ margin: '0 0 24px', fontSize: 13.5, color: '#6B5E4F', lineHeight: 1.6 }}>
            Your grace period has ended, so editing is disabled. You can still view and export
            your tree — resubscribe anytime to pick up right where you left off.
          </p>
          <button
            onClick={onUpgradeClick}
            style={{
              width: '100%', padding: '13px 0', borderRadius: 10, border: 'none',
              background: 'linear-gradient(135deg, #C4975A 0%, #A07840 100%)',
              color: '#2C2418', fontSize: 14, fontWeight: 700, cursor: 'pointer', marginBottom: 10,
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            Resubscribe
          </button>
          <button
            onClick={() => setDismissedBlocked(true)}
            style={{
              width: '100%', padding: '11px 0', borderRadius: 10, border: '1.5px solid #D5CAB8',
              background: '#fff', color: '#6B5E4F', fontSize: 13, fontWeight: 600, cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            Continue in read-only mode
          </button>
        </div>
      </div>
    );
  }

  return null;
}
